export default __webpack_public_path__ + "static/media/fauna-docs-2018.84588d96.png";